<template>
  <div class="px-4 py-3">
    <vetster-input
      id="weight"
      ref="weightInput"
      v-model="v$.inputs.weight.value.$model"
      is-rebranded
      type="text"
      name="weight"
      :label="weightLabel"
      :error="hasError('weight.value', v$.inputs.weight.value.$error)"
      :shake="shouldShake('weight.value', v$.inputs.weight.value.$error)"
      :feedback="getErrorMessage('weight.value', v$.inputs.weight.value.$error, $t('pets.errors.please-enter-a-valid-measurement'))"
      @update:modelValue="updateWeight"
    />
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import {
  decimal,
  maxValue,
  required,
} from '@vuelidate/validators';
import { mapGetters } from 'vuex';

import ParseErrors from '@/mixins/ParseErrors';
import PetWeight from '@/mixins/PetWeight';

export default {
  name: 'VetsterWeightForm',

  mixins: [
    ParseErrors,
    PetWeight,
  ],

  props: {
    formInputs: {
      type: Object,
      default: () => ({
        weight: {
          value: null,
          is_metric: 1,
        },
      }),
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      inputs: {
        weight: {
          value: '',
          is_metric: 1,
        },
      },
    };
  },

  computed: {
    ...mapGetters(['getUser']),

    isImperialSystemUsed() {
      return this.getUser.locale === 'en-US';
    },

    weightLabel() {
      if (this.inputs.weight.is_metric) {
        return `${this.$t('pets.weight')} (kg)`;
      }

      return `${this.$t('pets.weight')} (lbs)`;
    },
  },

  validations: {
    inputs: {
      weight: {
        value: {
          required,
          decimal,
          maxValue: maxValue(5000),
        },
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.weightInput?.focus();
      }, 400);
    });

    this.setWeight();
  },

  methods: {
    setWeight() {
      this.inputs.weight = this.petWeightInputs(this.formInputs);
      this.inputs.weight.is_metric = this.isImperialSystemUsed ? 0 : 1;
    },

    updateWeight() {
      this.$store.commit('errors/clear');
      this.v$.inputs.$reset();
      this.v$.inputs.$touch();

      if (this.v$.inputs.$invalid) {
        this.shakeErrors = true;
        this.removeShake();

        return;
      }

      this.$emit('input', {
        ...this.formInputs,
        weight: this.inputs.weight,
      });
    },
  },
};
</script>
